import { useCallback } from 'react';

import { useListUserPaymentMethods, useSelectHasEitherCardTypes } from '@givebacks/api/core';
import { Alert, Flex, Group, Stack, Text, Title } from 'ui';
import { useMap } from '~/components/Map/context/useMapContext';
import { MapLocationSearch } from '~/components/Map/inputs/MapLocationSearch';
import { AddCredentialEarnCard } from '~/pages/rewards/components/AddCredentialCard';

import { FilterModalButton } from '../FilterModal/FilterModal';

const SearchHeader = () => {
  return (
    <Group justify="space-between" wrap="nowrap">
      <Title fz={18} order={4}>
        Dining Rewards
      </Title>
      <FilterModalButton />
    </Group>
  );
};

const MissingCardAlert = () => {
  const { data: hasPartnerCard } = useSelectHasEitherCardTypes();
  const { data: hasCards } = useListUserPaymentMethods((cards) => !!cards.length);

  return (
    <Alert.Transition mounted={(hasCards && !hasPartnerCard) ?? false} type="warning">
      <Flex gap="xs">
        <Text type="body" fw={500} flex={1}>
          Your linked card is not eligible to receive cashback.
        </Text>
        {/* TODO: Uncomment when AC's for button functionality exist */}
        {/* <ButtonMantine size="xs" variant="subtle">
      Learn More
    </ButtonMantine> */}
      </Flex>
    </Alert.Transition>
  );
};

const EarnInStoreSearchHeader = () => {
  const { setMapCenter } = useMap();

  const handlePlaceSelect = useCallback(
    (place: google.maps.places.PlaceResult | null) => {
      if (place && place.geometry?.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        setMapCenter({ lat, lng });
      }
    },
    [setMapCenter]
  );

  return (
    <Stack>
      <SearchHeader />
      <AddCredentialEarnCard />
      <MissingCardAlert />
      <MapLocationSearch onPlaceSelect={handlePlaceSelect} />
    </Stack>
  );
};

export { EarnInStoreSearchHeader };
